export enum OrigemConsultaControleEstoqueEnum {
  ControleEstoque = 1,
  InventarioEstoque = 2,
}
